import { Inject, Injectable } from '@angular/core';
import {
  ProductModel,
  StorePageStore,
  STORE_SERVICE,
  IStoreService,
} from '@boxx/store-core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import * as fromCouponsActions from './store-coupons.actions';

@Injectable()
export class StoreCouponsEffects {
  loadCoupons$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromCouponsActions.loadCouponsBeginAction),
      switchMap(() =>
        this.service.loadCoupons().pipe(
          mergeMap((payload) => [
            fromCouponsActions.loadCouponsuccessAction({ payload }),
            fromCouponsActions.clearCouponsuccessErrorDataAction(),
          ]),
          catchError((errors) => {
            console.error('StoreEffects.loadCoupons$ ERROR', errors);
            return of([
              fromCouponsActions.loadCouponsFailAction({ errors }),
              fromCouponsActions.clearCouponsuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  createCoupon$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromCouponsActions.createCouponBeginAction),
      withLatestFrom(this.storePageStore.couponsStore.data$),
      switchMap(([action, couponsData]: [any, any[]]) =>
        this.service.createCoupon(action.payload).pipe(
          mergeMap((data) => {
            const payload  = {
              coupons: couponsData,
              newCoupon: data
            };

            return [
              fromCouponsActions.createCouponSuccessAction({ payload }),
              fromCouponsActions.clearCouponsuccessErrorDataAction(),
            ];
          }),
          catchError((errors) => {
            console.error('StoreEffects.createCoupon$ ERROR', errors);
            return of([
              fromCouponsActions.createCouponFailAction({ errors }),
              fromCouponsActions.clearCouponsuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  updateCoupon$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromCouponsActions.updateCouponBeginAction),
      withLatestFrom(this.storePageStore.couponsStore.data$),
      switchMap(([action, couponsData]: [any, ProductModel[]]) =>
        this.service.updateCoupon(action.payload).pipe(
          mergeMap((data) => {
            const payload = action.payload;

            return [
              fromCouponsActions.updateCouponSuccessAction({ payload }),
              fromCouponsActions.clearCouponsuccessErrorDataAction(),
            ];
          }),
          catchError((errors) => {
            console.error('StoreEffects.updateCoupon$ ERROR', errors);
            return of([
              fromCouponsActions.updateCouponFailAction({ errors }),
              fromCouponsActions.clearCouponsuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  deleteCoupon$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromCouponsActions.deleteCouponBeginAction),
      withLatestFrom(this.storePageStore.couponsStore.data$),
      switchMap(([action, couponsData]: [any, ProductModel[]]) =>
        this.service.deleteCoupon(action.id).pipe(
          mergeMap(() => {
            const payload = couponsData.filter((p) => p.id !== action.id);
            return [
              fromCouponsActions.deleteCouponSuccessAction({ payload }),
              fromCouponsActions.clearCouponsuccessErrorDataAction(),
            ];
          }),
          catchError((errors) => {
            console.error('StoreEffects.deleteCoupon$ ERROR', errors);
            return of([
              fromCouponsActions.deleteCouponFailAction({ errors }),
              fromCouponsActions.clearCouponsuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

getSingleCoupon$ = createEffect(() =>
  this.actions.pipe(
    ofType(fromCouponsActions.loadSingleCouponBeginAction),
    withLatestFrom(this.storePageStore.couponsStore.data$),
    switchMap(([action, couponsData]: [any, any[]]) =>
      this.service.getSingleCoupon(action.id).pipe(
        mergeMap((data) => {
          data.id = action.id;
          const payload = [data, ...couponsData];
          return [
            fromCouponsActions.loadSingleCouponSuccessAction({ payload }),
            fromCouponsActions.clearCouponsuccessErrorDataAction(),
          ];
        }),
        catchError((errors) => {
          console.error('StoreEffects.getSingleCoupon$ ERROR', errors);
          return of([
            fromCouponsActions.loadSingleCouponFailAction({ errors }),
            fromCouponsActions.clearCouponsuccessErrorDataAction(),
          ]).pipe(switchMap((d) => d));
        })
      )
    )
  )
);

  constructor(
    private actions: Actions,
    private storePageStore: StorePageStore,
    @Inject(STORE_SERVICE) private service: IStoreService
  ) {}
}
